import * as React from 'react';
import { EPageType } from '../shared/types/page';

let CareerContainer: React.ComponentType | null = null;
let CareerVacanciesContainer: React.ComponentType | null = null;
let CareerVacancyContainer: React.ComponentType | null = null;
let MarketingPage: React.ComponentType | null = null;
let AnalyticsPage: React.ComponentType | null = null;
let TechnologiesPage: React.ComponentType | null = null;
let careerLoading: Promise<void> | null = null;
let marketingLoading: Promise<void> | null = null;
let analyticsLoading: Promise<void> | null = null;
let technologiesLoading: Promise<void> | null = null;

export const loadCareerPage = (pageType?: EPageType): Promise<void> => {
  if (pageType === EPageType.CareerTeamMarketing) {
    if (!marketingLoading) {
      marketingLoading = import(
        /* webpackChunkName: "marketing" */ '../shared/containers/CareerTeamMarketing/MarketingPage'
      ).then(marketing => {
        MarketingPage = marketing.MarketingPage;
      });
    }

    return marketingLoading;
  }

  if (pageType === EPageType.CareerTeamAnalytics) {
    if (!analyticsLoading) {
      analyticsLoading = import(
        /* webpackChunkName: "analytics" */ '../shared/containers/CareerTeamAnalytics/AnalyticsPage'
      ).then(analytics => {
        AnalyticsPage = analytics.AnalyticsPage;
      });
    }

    return analyticsLoading;
  }

  if (pageType === EPageType.CareerTeamTechnologies) {
    if (!technologiesLoading) {
      technologiesLoading = import(
        /* webpackChunkName: "technologies" */ '../shared/containers/CareerTeamTechnologies/TechnologiesPage'
      ).then(technologies => {
        TechnologiesPage = technologies.TechnologiesPage;
      });
    }

    return technologiesLoading;
  }

  if (!careerLoading) {
    careerLoading = Promise.all([
      import(/* webpackChunkName: "career" */ '../shared/containers/Career/CareerContainer'),
      import(/* webpackChunkName: "career" */ '../shared/containers/CareerVacancies/CareerVacanciesContainer'),
      import(/* webpackChunkName: "career" */ '../shared/containers/CareerVacancy/CareerVacancyContainer'),
    ]).then(([career, vacancies, vacancy]) => {
      CareerContainer = career.CareerContainer;
      CareerVacanciesContainer = vacancies.CareerVacanciesContainer;
      CareerVacancyContainer = vacancy.CareerVacancyContainer;
    });
  }

  return careerLoading;
};

export const CareerPage: React.FC = () => {
  if (!CareerContainer) {
    throw new Error('Career page must be loaded before hydration');
  }

  return <CareerContainer />;
};

export const CareerVacanciesPage: React.FC = () => {
  if (!CareerVacanciesContainer) {
    throw new Error('Career vacancies page must be loaded before hydration');
  }

  return <CareerVacanciesContainer />;
};

export const CareerVacancyPage: React.FC = () => {
  if (!CareerVacancyContainer) {
    throw new Error('Career vacancy page must be loaded before hydration');
  }

  return <CareerVacancyContainer />;
};

export const CareerTeamMarketingPage: React.FC = () => {
  if (!MarketingPage) {
    throw new Error('Career marketing page must be loaded before hydration');
  }

  return <MarketingPage />;
};

export const CareerTeamAnalyticsPage: React.FC = () => {
  if (!AnalyticsPage) {
    throw new Error('Career analytics page must be loaded before hydration');
  }

  return <AnalyticsPage />;
};

export const CareerTeamTechnologiesPage: React.FC = () => {
  if (!TechnologiesPage) {
    throw new Error('Career technologies page must be loaded before hydration');
  }

  return <TechnologiesPage />;
};
